const flashFeatureState = state => state.features.common.flash;

export const allMessages = flashFeatureState;
